import React from 'react';
import PropTypes from 'prop-types';
import Star from '@material-ui/icons/Star';
import styles from './Ratings.scss';
import {formatToTenthPlace} from '../../lib/formatting';
import Linkify from '../Linkify/Linkify';
import Tooltip from '../Tooltip/Tooltip';

export const RmaFooterDisclaimer = () => <div className={`smText mb-3 ${styles.rmaFooterDisclaimer}`}>
  <sup>#</sup>Agent and/or Agency ratings, reviews and results (Reviews) are provided by <a href="https://www.ratemyagent.com.au" target="_blank" rel="nofollow noopener noreferrer"><u>RateMyAgent</u></a>.
  The views and opinions expressed do not reflect the views or opinions of Cotality.
  Cotality has no control over the contents of the Reviews, and accepts no responsibility for them,
  and to the maximum extent permitted by law excludes all liability for any loss or damage that may arise in connection with their publication.
</div>;


const Ratings = (props) => {
  const {
    id = '',
    overallStars,
    reviewCount,
    reviewsUrl,
    linkClass,
    containerClass,
    ratingClass,
    reviewCountClass,
    tooltipText,
  } = props;

  if (!reviewCount && !overallStars) {
    return null;
  }
  const reviewCountText = `${reviewCount} ${reviewCount > 1 ? 'Reviews' : 'Review'}`;
  return (
    <React.Fragment>
      <div id={`ratingsContainer-${id}`} className={containerClass || styles.rmaRatingContainer}>
        {!!overallStars &&
          <div className={ratingClass || styles.rmaRating}>
            <Star className={`mr-1 ${styles.starRating}`} />{formatToTenthPlace(overallStars)}
          </div>
        }
      </div>
      <div className="d-flex align-content-center flex-wrap flex-column my-auto">
        <div id={`reviewCountContainer-${id}`} className={reviewCountClass || `mt-3 ${styles.rmaReviewCount}`}>
          {!!reviewCount &&
            <Linkify
              url={reviewsUrl}
              linkClass={reviewsUrl ? linkClass : ''}
              content={reviewCountText}
            />
          }
        </div>
      </div>

      {tooltipText && !!overallStars &&
        <Tooltip
          id={`ratingsContainer-${id}`}
          text={tooltipText}
          trigger="hover"
          hideIcon
        />
      }
      {tooltipText && !!reviewCount &&
        <Tooltip
          id={`reviewCountContainer-${id}`}
          text={tooltipText}
          trigger="hover"
          hideIcon
        />
      }
    </React.Fragment>
  );
};

Ratings.propTypes = {
  id: PropTypes.string.isRequired, // page level id for multiple distinct tooltip targeting
  overallStars: PropTypes.number,
  reviewCount: PropTypes.number,
  reviewsUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  linkClass: PropTypes.string,
  containerClass: PropTypes.string,
  ratingClass: PropTypes.string,
  reviewCountClass: PropTypes.string,
  tooltipText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default Ratings;
